module.exports = __webpack_public_path__ + "static/img/cdhncy.cn.9c3f7fe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cdhncy.cn.svg
// module id = IQRD
// module chunks = 33